import { AuthenticatedTemplate } from "@azure/msal-react";
import { Button, FormControl } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { GetToken } from "../../../utils/auth-token";
import ReleaseSelectJob from "./release-select-job";

interface IProps {
  deployment: any;
  releaseId: string | undefined;
}

export default function ReleaseDeployStartButtonGitlab({
  deployment,
  releaseId,
}: IProps) {
  const [disable, setDisable] = useState<boolean>(false);
  const [force, setForce] = useState<boolean>(false);
  const [job, setJob] = useState<string>();

  const startDeployment = async () => {
    setDisable(true);
    try {
      const bearer = await GetToken();
      await axios
        .post(`${process.env.REACT_APP_QA_API}/deploy`, deployment, {
          params: {
            job_name: job,
            release_id: releaseId,
            force: force,
          },
          headers: {
            Authorization: bearer,
          },
        })
        .then((res) => {
          window.location.href = `${window.location.origin}/release-management/deploy/${res.data[0].release_package_id}`;
        });
    } catch (error) {}
    setDisable(false);
  };

  return (
    <AuthenticatedTemplate>
      <FormControl fullWidth>
        <ReleaseSelectJob job={job} setJob={setJob} />
        <br />
        <label>
          <input
            type="checkbox"
            checked={force}
            onChange={(event: any) => setForce(event.target.checked)}
          />
          Force a re-deployment of successful jobs
        </label>
        <Button
          variant="contained"
          onClick={async () => await startDeployment()}
          disabled={disable}
        >
          Start Deployment via Gitlab
        </Button>
        <br />
        <br />
      </FormControl>
    </AuthenticatedTemplate>
  );
}
